<template>
  <div id="sign-layer">
    <light-header :back="backUrl"></light-header>
    <div class="setcontrol-content" id="main">
      <div class="set-sign-control" id="set-sign">
        <div v-for="(item, usrIdx) in signUserArray" :key="usrIdx">
          <div class="set-title" :style="{ borderLeftColor: item.color }">
            签署方{{ usrIdx + 1 }}：{{
                item.personName ? item.personName : item.companyName
            }}
          </div>
          <div class="select-sign">
            <div class="sign-list">
              <div class="sign-item" v-if="item.signSubject == 'company'">
                <div class="sign-img-box drag-box seal-box" data-type="seal" :data-name="item.companyName"
                  :data-color="item.color" data-seal-type="companyCommon" :data-sign-id="item.signId" v-drop>
                  <img src="../../assets/images/seal.png" alt="" />
                </div>
                <span>印章</span>
              </div>
              <div class="sign-item" v-if="
              item.signSubject === 'person'">
                <div class="sign-img-box drag-box sign-box" data-type="sign" :data-name="item.personName"
                  :data-color="item.color" data-seal-type="person" :data-sign-id="item.signId" v-drop>
                  <img src="../../assets/images/sign.png" alt="" />
                </div>
                <span>签名</span>
              </div>
              <div class="sign-item" v-if="item.signSubject == 'company'">
                <div class="sign-img-box drag-box paging-box" data-type="paging" :data-name="item.companyName"
                  :data-color="item.color" data-seal-type="companyCommon" :data-sign-id="item.signId" v-drop>
                  <img src="../../assets/images/seal.png" alt="" />
                </div>
                <span>骑缝章</span>
              </div>
              <div class="sign-item" v-if="item.signSubject == 'company'">
                <div class="sign-img-box drag-box seal-box" data-type="sealLegal" :data-name="item.companyName"
                  :data-color="item.color" data-seal-type="companyLegal" :data-sign-id="item.signId" v-drop>
                  <img src="../../assets/images/sign.png" alt="" />
                </div>
                <span>法定代表人章</span>
              </div>
              <div class="sign-item" v-if="item.signSubject == 'company' && item.companyAgentAddress">
                <div class="sign-img-box drag-box seal-box" data-type="sealAgent" :data-name="item.companyName"
                  :data-color="item.color" data-seal-type="companyAgent" :data-sign-id="item.signId" v-drop>
                  <img src="../../assets/images/sign.png" alt="" />
                </div>
                <span>经办人章</span>
              </div>
              <div class="sign-item">
                <div class="sign-img-box drag-box date-box" data-type="date"
                  :data-name="item.personName ? item.personName : item.companyName" :data-color="item.color"
                  data-seal-type="date" :data-sign-id="item.signId" v-drop>
                  <img src="../../assets/images/date.png" alt="" />
                </div>
                <span>日期</span>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="set-title">签署方2：正元安服科技有限...</div>
				<div class="select-sign">
					<div class="sign-list">
						<div class="sign-item">
							<div class="sign-img-box">
								<img src="../../assets/images/sign.png" alt="">
							</div>
							<span>签名</span>
						</div>
						<div class="sign-item">
							<div class="sign-img-box">
								<img src="../../assets/images/seal.png" alt="">
							</div>
							<span>印章</span>
						</div>
						<div class="sign-item">
							<div class="sign-img-box">
								<img src="../../assets/images/date.png" alt="">
							</div>
							<span>日期</span>
						</div>
					</div>
				</div> -->
      </div>

      <!-- 滑动容器 -->
      <div class="contract-content" ref="cmain">
        <div class="contract-img-content">
          <div class="contract-imgs" id="contract-imgs" ref="contract">
            <div v-for="(item, idx) in signFileInfoArray" :key="idx" v-show="idx == active" class="file-item">
              <div class="img-wrap" v-for="(contract, index) in signFileInfoArray[active]
              .fileImgArray" :key="index" ref="imgWrap">
                <img :src="contract" class="contract-img" alt="" ondragstart="return false" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="contract-page">
        <div class="pages-head">
          <span class="big">文件列表</span>
          <span class="sub">共{{ signFileInfoArray.length }}份</span>
        </div>
        <el-collapse v-model="active" accordion @change="changeCollapse">
          <el-collapse-item :title="item.fileName" :name="idx" v-for="(item, idx) in signFileInfoArray" :key="idx">
            <div v-for="(img, imgIdx) in item.fileImgArray" :key="imgIdx" class="page-wrap">
              <img :src="img" alt="" ondragstart="return false" :class="{ current: item.current == imgIdx }"
                @click="handleChangeContractImg(imgIdx)" />
              <div class="page" :class="{ current: item.current == imgIdx }">
                {{ imgIdx + 1 + "/" + item.fileImgArray.length }}
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>

        <!-- <div class="all-page">
					<div class="page-item" v-for="(contract, index) in contractImgs" :key="index">
						<div class="page-img" @click="jumpPage(index)">
							<img :src="contract.src" alt="">
							<img v-if="contract.isSign" :src="iconImgs[parseInt(contract.isSign)-1]" class="sign-icon" alt="">
						</div>
						<p class="page-text">第{{index+1}}页</p>
					</div>
				</div> -->
      </div>
    </div>
    <div class="submit-btn clearfix" v-show="contractImgs.length > 0">
      <!-- <el-button type="primary" class="submit" @click="returnHandle">退回</el-button> -->
      <el-button type="primary" class="submit" @click="handleSave">完 成</el-button>
    </div>

    <sign-auth ref="auth" @getAuthCode="getAuthCodeHandle" :mode="['pin']"></sign-auth>
  </div>
</template>
<script>
// 新增功能点：多文件支持，同文件不同图片间任意拖拽，拖拽位置自动判定
import { Loading } from "element-ui";
import signAuth from "./sign-auth";
import lightHeader from "@/components/lightHeader";
import { getContractImgsApi } from "@/api/sign/flow";
import {
  getDraftInfo,
  saveLocation,
  getContractPositionApi,
  signSealApi,
  returnContractApi,
  autoLoginByTokenApi,
  getDatePngSrcApi,
  getCompanyLegalApi,
  getSealListApi,
  getContractApi,
  signSealOpenApi,
} from "@/api/sign/sign";
import { getUserSealInfoApi } from "@/api/common";
import { getCompanySealInfoApi } from "@/api/space/signatures";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { lang } from "moment";
import { mapState } from "vuex";
export default {
  components: {
    lightHeader,
    signAuth,
  },
  computed: {
    ...mapState(["companyList", "currentSpace"]),
    contractImgs() {
      if (this.signFileInfoArray[this.active]) {
        return this.signFileInfoArray[this.active].fileImgArray;
      } else {
        return [];
      }
    },
    backUrl() {
      if (this.$route.query.from) {
        return (
          "/temp-create?from=" +
          this.$route.query.from +
          "&taskId=" +
          this.taskId
        );
      } else {
        return true;
      }
    },
  },
  created() {
    // let token = this.$route.query.token;
    // if (getToken()) {
    // 	removeToken();
    // }
    // setToken(token, 1);
    // this.getSealListHandle();
    // this.getContractHandle();
    this.taskId = this.$route.query.taskId;
    this.handleGetDraftInfo();
  },
  mounted() {
    const _this = this;
    let disX = 0;
    let disY = 0;
    const receiverDom = document.querySelector("#contract-imgs");
    // const setHandlerDom = document.querySelector("#set-handler");
    receiverDom.onmousedown = () => {
      const event = event || window.event;
      event.stopPropagation();
      if (
        event.target.classList.contains("el-icon-close") ||
        event.target.classList.contains("contract-img") ||
        event.target.classList.contains("file-item")
      ) {
        return;
      }

      let target = event.target;
      while (
        target.tagName != "BODY" &&
        !target.className.includes("drag-box")
      ) {
        target = target.parentNode;
      }
      const type = target.getAttribute("data-type");
      const offsetLeft = target.offsetLeft;
      const offsetTop = target.offsetTop;
      const pageHeight = receiverDom
        .querySelectorAll(".file-item")
      [_this.active].querySelectorAll(".img-wrap")[0].offsetHeight;
      disX = event.clientX;
      disY = event.clientY;

      document.onmousemove = function (event) {
        const event2 = event || window.event;
        let iL = event2.clientX - disX + offsetLeft;
        let iT = event2.clientY - disY + offsetTop;

        const maxL = receiverDom.offsetWidth - target.offsetWidth;
        const maxT = receiverDom.offsetHeight - target.offsetHeight;

        // 骑缝章处理
        if (type == "paging") {
          iT <= 0 && (iT = 0);
          iT >= pageHeight - target.offsetHeight &&
            (iT = pageHeight - target.offsetHeight);
          target.style.left = maxL + "px";
          target.style.top = iT + "px";
        } else {
          iL <= 0 && (iL = 0);
          // iT <= 0 && (iT = 0);
          iL >= maxL && (iL = maxL);
          iT >= maxT && (iT = maxT);
          target.style.left = iL + "px";
          target.style.top = iT + "px";
        }

        // target.getElementsByClassName(
        // 	"delete-icon"
        // )[0].style.display = "none";
        return false;
      };
      document.onmouseup = function (event) {
        const event3 = event || window.event;

        // 骑缝章处理
        if (type == "paging") {
          // 更改每一个骑缝章的 top 值
          const allTargetPagingDoms = receiverDom
            .querySelectorAll(".file-item")
          [_this.active].querySelectorAll(
            '.paging-box[data-paging="' +
            target.getAttribute("data-paging") +
            '"]'
          );
          for (let i = 0; i < allTargetPagingDoms.length; i++) {
            allTargetPagingDoms[i].style.top = target.style.top;
          }
        } else {
          const pageHeight = receiverDom
            .querySelectorAll(".file-item")
          [_this.active].querySelectorAll(".img-wrap")[0].offsetHeight;
          _this.judgePage(
            target,
            +target.style.top.split("px")[0],
            pageHeight,
            target.offsetHeight
          );

          receiverDom
            .querySelectorAll(".file-item")
          [_this.active].querySelectorAll(".img-wrap")
          [target.getAttribute("data-page")].appendChild(target);
        }

        // target.getElementsByClassName("delete-icon")[0].style = "";

        document.onmousemove = null;
        document.onmouseup = null;
      };
    };

    window.addEventListener("scroll", this.scrollEventHandler, true);

    // this.getDatePngSrcHandle()
    // this.getUserSealInfoHandle()
    // getSealListApi().then(res => {});
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollEventHandler, true);
  },
  watch: {},
  data() {
    return {
      taskId: "",
      signFileInfoArray: [],
      signUserArray: [],
      active: 0,
      scrollWatchStatus: true, //点击右侧缩略图时，暂时停止监听页面滚动
      contractWidth: null,
      contractHeight: null,

      showTip: true,
      showCustom: false,
      contractH: null,
      setContractH: null,
      // contractImgs: [],
      selectId: "",
      signImgs: [],
      iconImgs: [
        require("../../assets/images/sign/sign-icon.png"),
        require("../../assets/images/sign/sign-icon2.png"),
      ],
      stitle: " ",
      isTime: "0",
      scrollTop: 0,
      signatoryId: 456,
      renderOK: false,
      positionList: [],
      sealList: [],
      code: "",
      pin: "",
      approvalNum: 0,
      hrefFrom: this.$route.query.hrefFrom,
      dateList: [],
      dateSrc: "",
      lastActive: "",

      pagingId: 0, // 骑缝章id
      colors: ["#3296FA", "#3cc", "#67C23A", "#f63", "#E6A23C"]
    };
  },
  methods: {
    randomColor() {
      var color = "#";
      var colorArr = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
      for (let i = 0; i < 6; i++) {
        var cur = randomNum(15, 0);
        color += colorArr[cur];
      }
      function randomNum(max, min) {
        return Math.floor(Math.random() * (max - min + 1) + min)
      }
      return color;
    },
    scrollEventHandler(e) {
      let timeId;
      e = e || window.event;
      if (
        e.target.classList &&
        e.target.classList.contains("contract-content")
      ) {
        clearTimeout(timeId);
        timeId = setTimeout(() => {
          this.handleScroll();
        }, 100);
        // this.handleScroll();
      } else {
        clearTimeout(timeId);
      }
    },
    changeCollapse() {
      if (this.active === "") {
        this.active = this.lastActive;
      }
      this.lastActive = this.active;
      // this.$forceUpdate();
      this.signFileInfoArray[this.active].current = 0;
      document
        .getElementById("contract-imgs")
        .getElementsByClassName("file-item")
      [this.active].getElementsByClassName("img-wrap")[0]
        .scrollIntoView({
          behavior: "auto", // 平滑过渡
          block: "start", // 上边框与视窗顶部平齐。默认值
        });
    },
    handleScroll() {
      // dom滚动位置
      let scrollTop =
        document.getElementsByClassName("contract-content")[0].scrollTop;
      // console.log(scrollTop)
      if (this.scrollWatchStatus) {
        let scaleFactor = 1;
        this.signFileInfoArray[this.active].fileImgArray.map((v, i) => {
          let offsetTop = document
            .getElementById("contract-imgs")
            .getElementsByClassName("file-item")
          [this.active].getElementsByClassName("img-wrap")[i].offsetTop;
          // 获取监听元素本身高度
          let scrollHeight = document
            .getElementById("contract-imgs")
            .getElementsByClassName("file-item")
          [this.active].getElementsByClassName("img-wrap")[i].scrollHeight;

          if (
            scrollTop >= offsetTop &&
            scrollTop <= offsetTop + scrollHeight * scaleFactor
          ) {
            this.signFileInfoArray[this.active].current = i;
          }
        });
      }
    },
    handleChangeContractImg(imgIdx) {
      let timer;
      this.signFileInfoArray[this.active].current = imgIdx;
      this.scrollWatchStatus = false;
      clearTimeout(timer);
      timer = setTimeout(() => {
        document
          .getElementById("contract-imgs")
          .getElementsByClassName("file-item")
        [this.active].getElementsByClassName("img-wrap")
        [imgIdx].scrollIntoView({
          behavior: "auto", // smooth 平滑过渡
          block: "start", // 上边框与视窗顶部平齐。默认值
        });

        let timer;
        clearTimeout(timer);
        timer = setTimeout(() => {
          this.scrollWatchStatus = true;
        }, 1300);
      }, 0);
    },

    handleGetDraftInfo() {
      getDraftInfo({
        taskId: this.taskId,
      }).then((res) => {
        if (res.code != "200") {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          res.data.signFileInfoArray.map((item) => {
            item.current = 0;
          });
          this.signFileInfoArray = res.data.signFileInfoArray;
          res.data.signUserArray.map((item, idx) => {
            if (idx <= this.colors.length - 1) {
              item.color = this.colors[idx];
            } else {
              item.color = this.randomColor();
            }
          })
          this.signUserArray = res.data.signUserArray;
          this.lastActive = this.active;
          this.$nextTick(() => {
            document.getElementsByClassName("contract-img")[0].onload = (
              ev
            ) => {
              this.contractWidth = ev.target.offsetWidth;
              this.contractHeight = ev.target.offsetHeight;
              document.getElementsByClassName("contract-img")[0].onload = null;
            };
            let collapseContentNodeList = document
              .getElementsByClassName("contract-page")[0]
              .getElementsByClassName("el-collapse-item__content");
            for (
              let i = 0, len = collapseContentNodeList.length;
              i < len;
              i++
            ) {
              // console.log(document.getElementsByClassName("contract-page")[0].offsetHeight)
              collapseContentNodeList[i].style.maxHeight =
                document.getElementsByClassName("contract-page")[0]
                  .offsetHeight -
                45 -
                48 * res.data.signFileInfoArray.length +
                "px";
            }
          });
        }
      });
    },

    /**
     *@method judgePage
     *@description 判定落在哪页，只针对 top 值
     *@param {Object} target 判定目标 dom 对象
     *@param {Number} targetTop 判定目标 dom 对象 top 值
     *@param {Number} pageHeight 外层 dom 对象高度
     *@param {Number} offsetHeight 判定目标 dom 对象高度
     *@return 无返回，改变原对象
     */
    judgePage(target, targetTop, pageHeight, offsetHeight) {
      let gutterHeight = 0;
      if (document.querySelectorAll(".img-wrap")[1]) {
        gutterHeight = +window
          .getComputedStyle(document.querySelectorAll(".img-wrap")[1], null)
          .marginTop.split("px")[0];
      }
      // 判定范围
      const judgeScope = (offsetHeight - gutterHeight) / 2 + gutterHeight;
      const judgeExpression =
        targetTop -
        (Math.ceil(targetTop / (pageHeight + gutterHeight)) *
          (pageHeight + gutterHeight) -
          (gutterHeight + offsetHeight) / 2);
      // 多页计算

      let divider = target.getAttribute("data-page")
        ? +target.getAttribute("data-page")
        : 0;

      divider += Math.floor(targetTop / (pageHeight + gutterHeight));

      if (divider < 0) {
        divider = 0;
        target.style.top = 0;
      } else {
        if (Math.abs(judgeExpression) < judgeScope) {
          // 进入判定范围
          const nextPageHeight =
            (pageHeight + gutterHeight) *
            Math.ceil(targetTop / (pageHeight + gutterHeight));
          if (judgeExpression <= 0) {
            // 移到上一页
            target.style.top = pageHeight - offsetHeight + "px";
          } else {
            // 移到下一页
            target.style.top = 0 + "px";
            divider++;
          }
        } else {
          target.style.top =
            ((pageHeight + gutterHeight + targetTop) %
              (pageHeight + gutterHeight)) +
            "px";
        }
      }

      if (divider > this.contractImgs.length - 1) {
        divider = this.contractImgs.length - 1;
        target.style.top = pageHeight - offsetHeight + "px";
      }

      target.setAttribute("data-page", divider);
    },

    handleSave() {
      let signUserArray = this.signUserArray.map((item) => {
        return {
          signUserId: item.signId,
          sealPositionArray: [],
          signSubject: item.signSubject,
          signSubjectName: item.signSubject == "company" ? item.companyName : item.personName
        };
      });
      let pushedFlagArr = [];
      Array.from(
        document.querySelector("#contract-imgs").querySelectorAll(".drag-box")
      ).map((item) => {
        let x = parseInt(
          (Number(item.style.left.split("px")[0]) / this.contractWidth) * 50000
        );
        let y = parseInt(
          (Number(item.style.top.split("px")[0]) / this.contractHeight) * 50000
        );
        let found = signUserArray.find((signUserItem) => {
          return signUserItem.signUserId == item.getAttribute("data-sign-id");
        });
        if (found) {
          if (item.getAttribute("data-type") == "paging") {
            // 骑缝章只需传入一个位置
            if (pushedFlagArr.indexOf(item.getAttribute("data-paging")) == -1) {
              found.sealPositionArray.push({
                signFileId:
                  this.signFileInfoArray[item.getAttribute("data-file")].fileId,
                sealType: item.getAttribute("data-seal-type"),
                sealLocationType: "paging",
                positionY: y,
              });
              pushedFlagArr.push(item.getAttribute("data-paging"));
            }
          } else {
            found.sealPositionArray.push({
              signFileId:
                this.signFileInfoArray[item.getAttribute("data-file")].fileId,
              sealType: item.getAttribute("data-seal-type"),
              sealLocationType: "position",
              positionPage: Number(item.getAttribute("data-page")) + 1, // 页数从1开始
              positionX: x,
              positionY: y,
            });
          }
        }
      });
      // let nullFlag = signUserArray.every((item) => {
      //   return !item.sealPositionArray.length;
      // });
      // if (nullFlag) {
      //   this.$message({
      //     showClose: true,
      //     message: "请为每个签署方指定盖章位置",
      //     type: "warning",
      //   });
      //   return;
      // }
      // 指定签章校验
      // 个人需要至少拖一个个人签名框
      // 企业需要至少拖一个企业章框或骑缝章框
      // 只拖日期框不能发起签署
      let checkItemArr = [];
      signUserArray.map((item, idx) => {
        if (item.signSubject == "company") {
          if (!item.sealPositionArray.some(_item => {
            return _item.sealType == "companyCommon" || _item.sealType == "paging"
          })) {
            checkItemArr.push(item)
          }
        } else {
          if (!item.sealPositionArray.some(_item => {
            return _item.sealType == "person"
          })) {
            checkItemArr.push(item)
          }
        }

        // item.sealPositionArray.map((_item) => {
        //   if (
        //     item.signSubject == "company" &&
        //     (_item.sealType == "companyCommon" || _item.sealType == "paging")
        //   ) {
        //     checkFlagNumberArr[idx] += 1;
        //   }
        //   if (item.signSubject == "person" && _item.sealType == "person") {
        //     checkFlagNumberArr[idx] += 1;
        //   }
        // });
      });
      // let signUserArray
      if (checkItemArr.length) {
        let msg = "";
        checkItemArr.map(item => {
          msg += (item.signSubjectName + (item.signSubject == "company" ? "企业章位置未指定；\n\n\n\n\n\n" : "签名位置未指定；\n\n\n\n\n\n"))
        })
        this.$message({
          showClose: true,
          message: msg,
          type: "warning",
        });
        return;
      }
      saveLocation({
        taskId: this.taskId,
        status: "waitSend",
        signUserArray: signUserArray,
      }).then((res) => {
        if (res.code != "200") {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "success",
          });
          this.$router.push({
            name: "ContractList",
            query: {
              status: "waitSend",
            },
          });
        }
      });
    },

    getContractHandle() {
      getContractApi({
        contractId: this.$route.query.contractId,
      })
        .then((res) => {
          if (res.code != "200") {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            let imgArr = res.result.pngList.map((el) => {
              return el + "&nocache=" + new Date().getTime();
            });

            imgArr.forEach((img) => {
              this.contractImgs.push({
                isSign: "",
                src: img,
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSealListHandle() {
      getSealListApi().then((res) => {
        if (res.code != "200") {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          // let sealList = []
          res.result.sealList
            .map((el) => {
              el.sealSubject = 1;
              return el;
            })
            .forEach((seal) => {
              this.signImgs.push(seal);
            });

          // this.getCompanyLegalHandle();
        }
      });
    },
    getContractPositionHandle() {
      getContractPositionApi({
        contractId: this.$route.query.contractId,
        signingBody: this.$route.query.signType || 0,
        companyId: this.$route.query.companyId || "",
      })
        .then((res) => {
          if (res.code !== "0") {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            res.result.positionList.forEach((pos) => {
              var sealType;
              var sealSubject; // 0是个人，1是经办人。2是企业
              if (pos.sealSubject == "0") {
                sealType = "个人";
                sealSubject = 0;
              }

              if (this.$route.query.companyId && pos.sealSubject == "1") {
                sealType = "经办人";
                sealSubject = 0;
              }

              if (pos.sealSubject == "2") {
                sealType = "企业";
                sealSubject = 1;
              }

              if (pos.sealSubject == "3") {
                sealType = "时间";
                sealSubject = 3;
              }

              if (pos.sealSubject == "4") {
                sealType = "法定代表人";
                sealSubject = 4;
              }

              if (pos.sealSubject != "3") {
                this.positionList.push({
                  sealType: sealType,
                  isPaging: pos.sealType,
                  left: pos.x,
                  top: pos.y,
                  page: pos.page,
                  createdId: pos.id,
                  signId: "",
                  signImg: "",
                  sealSubject: sealSubject,
                });
              } else {
                this.dateList.push({
                  left: pos.x,
                  top: pos.y,
                  page: pos.page,
                  src: this.dateSrc,
                });

                console.log(this.dateList);
              }
            });

            this.getContractImgsHandle();
          }

          this.$nextTick(function () {
            this.renderOK = true;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getUserSealInfoHandle() {
      getUserSealInfoApi().then((res) => {
        if (res.code !== "0") {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          res.result.sealList
            .map((el) => {
              el.sealData =
                ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) +
                el.sealData +
                getToken() +
                "&nocache=" +
                new Date().getTime();
              el.sealSubject = "0";
              el.isAuthName = "";
              return el;
            })
            .forEach((seal) => {
              this.signImgs.push(seal);
            });

          if (this.$route.query.companyId) {
            this.getCompanySealInfoHandle();
          }
        }
      });
    },
    getCompanySealInfoHandle() {
      getCompanySealInfoApi({
        companyId: this.$route.query.companyId,
      }).then((res) => {
        if (res.code !== "0") {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          // let sealList = []
          res.result.sealList
            .map((el) => {
              el.sealData =
                ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) +
                el.sealData +
                getToken() +
                "&nocache=" +
                new Date().getTime();
              el.sealSubject = 1;
              // el.isAuthName =
              if (el.isAuth == "1") {
                el.isAuthName = "已授权";
              } else {
                el.isAuthName = "需审批";
              }
              return el;
            })
            .forEach((seal) => {
              this.signImgs.push(seal);
            });

          this.getCompanyLegalHandle();
        }
      });
    },
    getCompanyLegalHandle() {
      getCompanyLegalApi({
        companyId: this.$route.query.companyId,
        nochche: new Date().getTime(),
      }).then((res) => {
        if (res.code !== "0") {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          // let sealList = []
          res.result.sealList
            .map((el) => {
              el.sealData =
                ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) +
                el.sealData +
                getToken() +
                "&nocache=" +
                new Date().getTime();
              el.sealSubject = 4;
              // el.isAuthName =
              if (el.isAuth == "1") {
                el.isAuthName = "已授权";
              } else {
                el.isAuthName = "需审批";
              }
              return el;
            })
            .forEach((seal) => {
              this.signImgs.push(seal);
            });

          // this.getCompanyLegalHandle()
        }
      });
    },
    getContractImgsHandle() {
      getContractImgsApi(this.$route.query.contractId)
        .then((res) => {
          if (res.code !== "0") {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            let imgArr = res.result.pngList.map((el) => {
              return (
                ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) +
                el +
                getToken() +
                "&nocache=" +
                new Date().getTime()
              );
            });

            imgArr.forEach((img) => {
              this.contractImgs.push({
                isSign: "",
                src: img,
              });
            });

            if (this.contractImgs.length > 0) {
              this.contractImgs.forEach((img, index) => {
                if (this.positionList.length > 0) {
                  this.positionList.forEach((pos) => {
                    if (index + 1 == pos.page) {
                      this.$nextTick(function () {
                        img.isSign = "1";
                      });
                    }
                  });
                }
              });
              this.$nextTick(() => {
                this.contractH =
                  document.querySelector(
                    "#contract-imgs"
                  ).children[0].offsetHeight;
                // console.log('签署时height：'+this.contractH)
                // console.log('签署时width：'+document.querySelector('#contract-imgs').children[0].offsetWidth)
                var _this = this;
                document.querySelector("#contract-imgs").children[0].onload =
                  function () {
                    _this.setContractH = setInterval(() => {
                      _this.contractH =
                        document.querySelector(
                          "#contract-imgs"
                        ).children[0].offsetHeight;
                    }, 500);
                  };
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDatePngSrcHandle() {
      getDatePngSrcApi().then((res) => {
        if (res.code !== "0") {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          this.dateSrc = res.result.imgBase64;
          this.getContractPositionHandle();
        }
      });
    },
    back() {
      if (this.$route.query.companyId) {
        // 企业
        this.companyList.forEach((company) => {
          if (company.companyId == this.$route.query.companyId) {
            this.$store.commit("SET_CURRENT_SPACE", company);
          }
        });
        this.$router.push({
          path: "/company-space/contracts",
          query: {
            status: "all",
            companyId: this.$route.query.companyId,
          },
        });
      } else {
        // 个人
        this.$store.commit("SET_CURRENT_SPACE", {});
        this.$router.push({
          path: "/user-space/contracts",
          query: {
            status: "all",
          },
        });
      }
    },
    setSignId(sid, cid, posSubject, sealSubject) {
      var signImg;
      var pageSeals = [];

      if (posSubject !== sealSubject) {
        if (sealSubject == 0) {
          this.$message({
            showClose: false,
            message: "请拖至个人或经办人签署框内！",
            type: "warning",
          });

          return;
        }

        if (sealSubject == 1) {
          this.$message({
            showClose: false,
            message: "请拖至企业签署框内！",
            type: "warning",
          });

          return;
        }

        if (sealSubject == 4) {
          this.$message({
            showClose: false,
            message: "请拖至法定代表人签署框内！",
            type: "warning",
          });

          return;
        }
      }

      this.signImgs.forEach((item) => {
        if (item.id == sid) {
          signImg = item.sealData;
        }
      });

      this.positionList.forEach((item) => {
        if (item.createdId == cid) {
          item.signId = sid;
          item.signImg = signImg;
        }
      });

      for (var i = 0; i < this.contractImgs.length; i++) {
        for (var j = 0; j < this.positionList.length; j++) {
          if (i + 1 == this.positionList[j].page) {
            if (!this.positionList[j].signImg) {
              this.contractImgs[i].isSign = "1";
              break;
            } else {
              this.contractImgs[i].isSign = "2";
            }
          }
        }
      }
    },
    deleteSeal(id) {
      this.positionList.forEach((pos) => {
        if (pos.createdId === id) {
          pos.signId = "";
          pos.signImg = "";
        }
      });

      for (var i = 0; i < this.contractImgs.length; i++) {
        for (var j = 0; j < this.positionList.length; j++) {
          if (i + 1 == this.positionList[j].page) {
            if (!this.positionList[j].signImg) {
              this.contractImgs[i].isSign = "1";
              break;
            } else {
              this.contractImgs[i].isSign = "2";
            }
          }
        }
      }
    },
    jumpPage(page) {
      var sTop = 0;
      var allImgs = this.$refs.contract.querySelectorAll("img");
      for (var i = 0; i < page; i++) {
        sTop += allImgs[i].offsetHeight;
      }
      this.$refs.cmain.scrollTop = sTop;
    },
    authHandle() {
      // this.sealList = [];
      var bOk = true;
      // this.positionList.forEach(pos => {
      // 	this.sealList.push({
      // 		sealId: pos.signId,
      // 		positionId: pos.createdId
      // 	});
      // });

      // for (var i = 0; i < this.sealList.length; i++) {
      // 	if (!this.sealList[i].sealId) {
      // 		bOk = false;
      // 		this.$message({
      // 			showClose: false,
      // 			message: "当前合同尚未完成签署，请选择印章签署后再提交",
      // 			type: "warning"
      // 		});

      // 		break;
      // 	}
      // }

      if (bOk) {
        this.$refs.auth.dialogVisible = true;
      }
    },
    getAuthCodeHandle(data) {
      if (data.type == "sms") {
        this.code = data.code;
        this.pin = "";
      } else {
        this.code = "";
        this.pin = data.code;
      }

      this.signSealHandle();
    },
    signSealHandle() {
      if (!document.querySelectorAll(".contract-img")[0]) {
        return;
      }
      let loadingInstance = Loading.service({
        fullscreen: true,
      });
      let positionLocationList = [];

      let contractWidth =
        +document.querySelectorAll(".contract-img")[0].offsetWidth;
      let contractHeight =
        +document.querySelectorAll(".contract-img")[0].offsetHeight;
      this.$refs.contract.querySelectorAll(".drag-box").forEach((item) => {
        positionLocationList.push({
          sealId: item.getAttribute("data-sealid"),
          pageIndex: +item.getAttribute("data-page") + 1,
          positionX: parseInt(
            (+item.style.left.split("px")[0] / contractWidth) * 50000
          ),
          positionY: parseInt(
            (+item.style.top.split("px")[0] / contractHeight) * 50000
          ),
        });
      });

      signSealOpenApi({
        contractId: this.$route.query.contractId,
        pin: this.pin,
        positionLocationList: positionLocationList,
      })
        .then((res) => {
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
          if (res.code != 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            this.$message({
              message: "签署成功！",
              type: "success",
            });
          }
        })
        .catch((err) => {
          this.$nextTick(() => {
            loadingInstance.close();
          });
          console.log(err);
        });
    },
    returnHandle() {
      this.$confirm("确认要退回吗？", "温馨提示", {
        confirmButtonText: "退回",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          returnContractApi({
            contractId: this.$route.query.contractId,
            signingBody: this.$route.query.signType,
            companyId: this.$route.query.companyId,
          })
            .then((res) => {
              if (res.code !== "0") {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              } else {
                this.$message({
                  showClose: true,
                  message: "退回成功！",
                  type: "success",
                });

                setTimeout(() => {
                  this.$router.push({
                    path: "/",
                  });
                }, 2000);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
  },
  directives: {
    drop: {
      inserted: function (el, binding, vnode) {
        var disX = 0;
        var disY = 0;
        var contractImgs =
          document.querySelector("#contract-imgs").parentNode.parentNode;
        var contractDom = document.querySelector("#contract-imgs");
        var main = document.querySelector("#main");
        var setSign = document.querySelector("#set-sign");
        var customDrags;
        var signId = "";
        var sealSubject; // 章类型
        var posSubject; // 需要的章类型

        // 获取所有图片，拖拽不在浏览器新页面打开
        Array.from(document.getElementsByTagName("img")).forEach((img) => {
          img.ondragstart = function () {
            return false;
          };
        });

        el.onmousedown = function () {
          customDrags = document.querySelectorAll(".custom-drag");
          el.style.background = "#ddd";
          var event = event || window.event;
          disX = event.clientX - this.offsetLeft;
          disY = event.clientY - this.offsetTop + setSign.scrollTop;
          var cloneTemp = el.cloneNode(true);
          cloneTemp.style.position = "fixed";
          cloneTemp.style.zIndex = 999;
          cloneTemp.style.left = this.currentStyle
            ? this.currentStyle["left"]
            : getComputedStyle(this, null)["left"];
          // cloneTemp.style.top = this.currentStyle ? this.currentStyle["top"] : getComputedStyle(this, null)["top"];
          cloneTemp.style.top = event.clientY - disY + main.offsetTop + "px";
          cloneTemp.style.cursor = "grab";
          cloneTemp.style.opacity = ".7";

          signId = el.getAttribute("data-signid");
          sealSubject = el.getAttribute("data-subject");
          // signId = el.dataset.signid || getDataset(el).signid

          el.parentNode.appendChild(cloneTemp);

          document.onmousemove = function (event) {
            var event = event || window.event;
            var iL = event.clientX - disX;
            var iT = event.clientY - disY;
            var maxL = document.documentElement.clientWidth - el.offsetWidth;
            var maxT = document.documentElement.clientHeight - el.offsetHeight;
            iL <= 0 && (iL = 0);
            iT <= 0 && (iT = 0);
            iL >= maxL && (iL = maxL);
            iT >= maxT && (iT = maxT);

            cloneTemp.style.left = iL + main.offsetLeft + "px";
            // console.log(iT)
            cloneTemp.style.top = iT + main.offsetTop + "px";

            // console.log(cloneTemp.style.top)
            // console.log(cloneTemp.style.left)
            return false;
          };

          document.onmouseup = function (event) {
            el.style.background = "#fff";
            // var event = event || window.event;
            document.onmousemove = null;
            document.onmouseup = null;

            event = event || window.event;

            let targetTop = +cloneTemp.style.top.split("px")[0];
            let targetLeft = +cloneTemp.style.left.split("px")[0];
            let targetWidth = +cloneTemp.offsetWidth;
            let targetHeight = +cloneTemp.offsetHeight;
            document.onmousemove = null;
            document.onmouseup = null;

            let contractDomLeft = contractDom.getBoundingClientRect().left;
            let contractDomTop = contractDom.getBoundingClientRect().top;

            if (
              targetLeft >= contractDomLeft &&
              targetLeft <=
              contractDomLeft + contractDom.offsetWidth - targetWidth &&
              targetTop >= contractDomTop &&
              targetTop <=
              contractDomTop + contractDom.offsetHeight - targetHeight
            ) {
              targetTop = targetTop - contractDomTop;
              targetLeft = targetLeft - contractDomLeft;
              const pageHeight = contractDom
                .querySelectorAll(".file-item")
              [vnode.context.active].querySelectorAll(
                ".contract-img"
              )[0].offsetHeight;

              //添加delete-icon
              // const deleteDom = document.createElement("i");
              // deleteDom.setAttribute(
              // 	"class",
              // 	"el-icon-circle-close delete-icon"
              // );
              // deleteDom.addEventListener("click", function() {
              // 	cloneTemp.parentNode.removeChild(cloneTemp);
              // });
              // cloneTemp.appendChild(deleteDom);
              //

              const headDom = document.createElement("div");
              cloneTemp.style.borderColor = cloneTemp.getAttribute("data-color");
              headDom.setAttribute("class", "box-head");
              headDom.style.background = cloneTemp.getAttribute("data-color");
              const textDom = document.createElement("span");
              let type = cloneTemp.getAttribute("data-type");
              let name = cloneTemp.getAttribute("data-name");
              let fullText = "";
              if (type == "sign") {
                fullText = "签名";
              } else if (type == "seal") {
                fullText = "企业章";
              } else if (type == "sealLegal") {
                fullText = "企业法人章";
              } else if (type == "sealAgent") {
                fullText = "经办人章";
              } else if (type == "date") {
                fullText = "日期";
              } else if (type == "paging") {
                fullText = "骑缝章";
              }
              textDom.innerHTML = fullText;
              textDom.setAttribute("title", fullText);
              const deleteDom = document.createElement("i");
              deleteDom.setAttribute("class", "el-icon-close");
              deleteDom.addEventListener("click", function () {
                cloneTemp.parentNode.removeChild(cloneTemp);
              });
              headDom.appendChild(textDom);
              headDom.appendChild(deleteDom);
              cloneTemp.appendChild(headDom);
              cloneTemp.removeChild(cloneTemp.querySelectorAll("img")[0]);
              cloneTemp.setAttribute("data-file", vnode.context.active);
              cloneTemp.style.position = "absolute";
              cloneTemp.style.left = targetLeft + "px";
              cloneTemp.style.top = targetTop + "px";
              cloneTemp.style.opacity = "1";
              contractDom.appendChild(cloneTemp);
              targetWidth = +cloneTemp.offsetWidth;
              targetHeight = +cloneTemp.offsetHeight;

              // 签框不能超出合同图片宽，骑缝章处理
              if (
                targetLeft >= contractDom.offsetWidth - targetWidth ||
                type == "paging"
              ) {
                cloneTemp.style.left =
                  contractDom.offsetWidth - targetWidth + "px";
              }

              vnode.context.judgePage(
                cloneTemp,
                targetTop,
                pageHeight,
                targetHeight
              );

              // 向每一页添加骑缝章
              if (type == "paging") {
                const targetPagingId =
                  "paging" + vnode.context.active + vnode.context.pagingId;
                cloneTemp.setAttribute("data-paging", targetPagingId);
                vnode.context.pagingId++;
                const allPageDoms = contractDom
                  .querySelectorAll(".file-item")
                [vnode.context.active].querySelectorAll(".img-wrap");
                for (let i = 0; i < allPageDoms.length; i++) {
                  let secondColoneTemp =
                    i == 0 ? cloneTemp : cloneTemp.cloneNode(true);
                  // secondColoneTemp.setAttribute("data-page", i);
                  secondColoneTemp
                    .getElementsByClassName("el-icon-close")[0]
                    .addEventListener("click", function () {
                      // 删除每一个骑缝章
                      const allTargetPagingDoms = contractDom
                        .querySelectorAll(".file-item")
                      [vnode.context.active].querySelectorAll(
                        '.paging-box[data-paging="' + targetPagingId + '"]'
                      );
                      for (let i = 0; i < allTargetPagingDoms.length; i++) {
                        allTargetPagingDoms[i].parentNode.removeChild(
                          allTargetPagingDoms[i]
                        );
                      }
                    });
                  allPageDoms[i].appendChild(secondColoneTemp);
                }
                // allPageDoms[0].appendChild(cloneTemp);
              } else {
                contractDom
                  .querySelectorAll(".file-item")
                [vnode.context.active].querySelectorAll(".img-wrap")
                [cloneTemp.getAttribute("data-page")].appendChild(cloneTemp);
              }
            } else {
              el.parentNode.removeChild(cloneTemp);
            }
          };
        };
      },
    },
    maxIndex: {
      inserted: function (el, binding) {
        var customDrags = document.getElementsByClassName("custom-drag");
        el.onclick = function () {
          for (var i = 0; i < customDrags.length; i++) {
            customDrags[i].style.zIndex = 9;
          }
          el.style.zIndex = 9999;
        };
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.select-sign {
  // width: 152px;
  margin: 20px 26px;
}

.sign-list {
  display: flex;
  flex-wrap: wrap;

}

.select-sign-title {
  font-size: 14px;
  color: #666666;
  text-align: center;
}

.sign-item {
  width: 46px;
  text-align: center;
  font-size: 0;
  // display: inline-block;
  margin: 2px 8px 2px;

  .sign-img-box {
    width: 46px;
    height: 46px;
    line-height: 46px;
    text-align: center;
    border: 1px solid #f0f0f5;
    border-radius: 4px;
    font-size: 0;

    img {
      width: 25px;
      height: auto;
      vertical-align: middle;
    }
  }

  span {
    display: inline-block;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    margin-top: 5px;
  }
}

.contract-content {
  /* width: 685px; */
  background: #f0f0f5;
  /* position: relative; */
  height: calc(100vh - 90px);

  overflow-y: auto;
  overflow-x: hidden;
  /* overflow: auto; */

  .drag-box {
    background: rgba(255, 255, 255, 0.7) !important;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #3296FA;

    &.sign-box {
      width: 128px;
      height: 128px;
    }

    &.seal-box {
      width: 128px;
      height: 128px;
    }

    &.date-box {
      width: 128px;
      height: 31px;
    }

    &.paging-box {
      width: 50px;
      height: 128px;
      border-radius: 8px 0 0 8px;
      // /deep/ .box-head {
      //   span {
      //     position: absolute;
      //     top: 40px;
      //     left: 4px;
      //     color: #aaa;
      //   }
      // }
    }

    &[data-seal-type="person"] {
      width: 64.5px;
      height: 64.5px;
    }

    &[data-seal-type="companyAgent"] {
      width: 64.5px;
      height: 64.5px;
    }

    &[data-seal-type="companyLegal"] {
      width: 64.5px;
      height: 64.5px;
    }

    /deep/ .box-head {
      width: 100%;
      min-height: 30px;
      color: #fff;
      background: #3296FA;
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 4px 4px 4px 6px;
      position: absolute;
      left: 0;
      top: 0;

      .el-icon-close {
        cursor: pointer;
        font-size: 16px;
        // padding: 5px;
        // position: absolute;
        // right: 5px;
      }
    }
  }
}

.contract-page {
  width: 238px;
  background: white;
  height: calc(100vh - 90px);
  overflow: hidden;

  .el-collapse {
    max-height: calc(100% - 45px);

    /deep/ .el-collapse-item {
      // height: 100%;
      .el-collapse-item__header {
        padding: 0 10px 0 15%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 95%;
        display: block;
        position: relative;

        .el-collapse-item__arrow {
          position: absolute;
          left: 5%;
          top: 0;
          bottom: 0;
          margin: auto 0;
          width: 13px;
          height: 13px;
        }
      }

      .el-collapse-item__wrap {

        // height: calc(100% - 48px);
        .el-collapse-item__content {
          overflow: auto;
          background: #f9f9ff;
          padding-top: 25px;
          padding-bottom: 1px;
        }
      }
    }
  }

  .pages-head {
    height: 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 17px;
    padding-right: 13px;

    .big {
      font-size: 16px;
      font-weight: bold;
      color: #333333;
    }

    .sub {
      font-size: 14px;
      font-weight: 400;
      color: #999999;
    }
  }

  .page-wrap {
    width: 160px;
    margin: 0 auto;

    img {
      display: block;
      margin: 0 auto;
      width: 100%;

      &.current {
        outline: 1px solid #3699ff;
        box-shadow: 0px 3px 10px 0px rgba(54, 153, 255, 0.1);
      }
    }

    .page {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      text-align: center;
      margin: 12px 0;

      &.current {
        color: #3699ff;
      }
    }
  }

  /* overflow-y: auto; */
  /* overflow-x: hidden; */
}

#sign-layer {
  background: #f0f0f5;
  height: 100vh;
  overflow: hidden;
}

// header {
//   // width: 100%;
//   // // height: 71px;
//   // background: rgba(35, 43, 58, 1);
//   // box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.19);
//   // line-height: 71px;
//   // overflow: hidden;
// }

// .header-center {
//   width: 1200px;
//   margin: 0 auto;
//   line-height: 71px;
//   height: 71px;
//   overflow: hidden;
//   position: relative;
// }

.return-index {
  height: 71px;
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 24px;
  color: #ffffff;
  line-height: 71px;
}

.setcontrol-content {
  width: 1200px;
  margin: 20px auto 0;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.set-sign-control {
  width: 238px;
  background: white;
  position: relative;
  z-index: 9;
  overflow-y: auto;
  height: calc(100vh - 90px);
}

.set-title {
  width: 190px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  border-left: 3px solid #3296FA;
  text-indent: 13px;
  margin: 20px 0 0 27px;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.contract-img-content {
  height: 100%;
}

.contract-imgs {
  position: relative;
  z-index: 1;
}

.contract-imgs .contract-img {
  display: block;
  width: 665px;
  height: auto;
  /* border-bottom: 2px solid #eee; */
  box-sizing: content-box;
  -ms-box-sizing: content-box;
}

.contract-imgs .orther-box-sign {
  max-width: 80px;
  max-height: 80px;
}

.contract-imgs .img-wrap {
  position: relative;
}

.contract-imgs .img-wrap+.img-wrap {
  margin-top: 30px;
}

/* .contract-img {
																																																											width: 685px;
																																																										} */

.custom-drag {
  width: 127px;
  height: 127px;
  border: 1px solid rgba(51, 204, 204, 1);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
  cursor: move;
  /* box-sizing: content-box;
																																																											-ms-box-sizing: content-box; */
}

.custom-content {
  width: 127px;
  height: 127px;
  background: rgba(255, 255, 255, 0.7);
  position: relative;
  z-index: 1;
}

.custom-drag-title {
  font-size: 16px;
  color: #000000;
  display: block;
  width: 127px;
  top: 50px;
  display: block;
  position: absolute;
  z-index: -1;
  text-align: center;
}

.custom-drag-time {
  position: absolute;
  bottom: 8px;
  text-align: center;
  font-size: 16px;
  color: #bbb;
  display: block;
  width: 127px;
  z-index: 9999;
}

.custom-drag-header {
  width: 109px;
  height: 33px;
  background: rgba(51, 204, 204, 1);
  line-height: 33px;
  font-size: 16px;
  color: #ffffff;
  padding: 0 10px;
  /* display: flex;
																																																											justify-content: space-between; */
  position: absolute;
  left: -1px;
  top: -33px;
}

.custom-drag-header .delete {
  cursor: pointer;
  float: right;
  margin-right: 5px;
}

.custom-delete {
  font-size: 14px;
  width: 60px;
  height: 22px;
  background: rgba(0, 0, 0, 0.5);
  text-align: center;
  color: #ffffff;
  display: block;
  line-height: 22px;
  position: absolute;
  left: 30px;
  bottom: -22px;
  display: none;
}

.all-page {
  width: 180px;
  margin: 30px auto 0;
}

.page-item {
  position: relative;
  height: 230px;
  margin-bottom: 22px;
}

.page-img {
  width: 177px;
  height: 238px;
  border: 1px solid rgba(240, 240, 245, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
  position: relative;
}

.page-img img {
  display: block;
  max-width: 177px;
  max-height: 198px;
}

.page-text {
  text-align: center;
  font-size: 14px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  color: #333333;
}

.sign-default,
.sign-orther {
  width: 152px;
  height: 152px;
  background: #f9f9f9;
  overflow: hidden;
  margin-top: 30px;
}

.sign-default-title {
  text-align: center;
  font-size: 14px;
  color: #999999;
  line-height: 34px;
}

.default-box,
.orther-sign-box {
  width: 80px;
  height: 80px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px auto 0;
  background: #ffffff;
  border: 1px solid rgba(229, 229, 229, 1);
  /* position: relative; */
}

.default-box img,
.orther-box .orther-box-sign {
  display: block;
  max-width: 80px;
  max-height: 80px;
  cursor: move;
}

/* .personal{
																																																										background: url('../../assets/images/sign/personal.png') no-repeat right top;
																																																										} */

.type-icon {
  position: relative;
  left: 88px;
  top: -81px;
  /* transform: translateY(-50px); */
}

.sign-name {
  font-size: 14px;
  color: #333333;
  text-align: center;
  line-height: 34px;
  margin-top: -6px;
}

.orther-title {
  text-align: center;
  font-size: 16px;
  color: #333333;
  margin-top: 30px;
}

.sign-orther {
  width: 152px;
  margin: 15px auto 0;
}

.sign-orther {
  margin-top: 0;
}

.orther-box {
  margin-top: 20px;
  margin-bottom: 10px;
  height: 114px;
}

.orther-list {
  margin-top: 15px;
  padding-bottom: 40px;
}

.custom-sign-box {
  width: 127px;
  height: 127px;
  position: absolute;
  top: 0;
  left: 0;
  /* border: 1px solid red; */
  overflow: hidden;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-sign-box img {
  display: block;
  max-height: 127px;
  max-width: 127px;
}

.submit-btn {
  width: 279px;
  height: 42px;
  position: fixed;
  left: 50%;
  bottom: 50px;
  margin-left: -168px;
  color: #ffffff;
  font-size: 16px;
  z-index: 999;
}

.submit-btn button {
  width: 100%;
  display: block;
  font-size: 16px;
  float: left;
}

.page-img .sign-icon {
  width: 44px;
  height: 44px;
  position: absolute;
  right: 0;
  top: 0;
}

.sign-auth {
  text-align: center;
  font-size: 12px;
  color: red;
  margin-top: -40px;
  height: 17px;
}

.default {
  margin-top: -55px;
}

.drag-box /deep/ .delete-icon {
  font-size: 28px;
  position: absolute;
  color: #fff;
  font-weight: bold;
  right: -15px;
  top: -15px;
  display: none;
  cursor: pointer;
  background: red;
  border-radius: 50%;
}

.drag-box:hover /deep/ .delete-icon {
  display: block;
}
</style>
